import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ErvHelpDialogData {
  title: string;
  sections: {
    title?: string;
    table: {
      headers: {
        title: string;
        key: string;
      }[];
      rows: Record<string, string>[];
    };
  }[];
}

@Component({
  selector: 'app-erv-help-dialog',
  templateUrl: './erv-help-dialog.component.html',
  styleUrls: ['./erv-help-dialog.component.scss'],
  standalone: false,
})
export class ErvHelpDialogComponent {
  protected helpItem = inject(MAT_DIALOG_DATA)?.helpItem;
  protected data = this.helpItem?.messageBox?.data as ErvHelpDialogData;

  protected headerRowList(section: ErvHelpDialogData['sections'][0]) {
    return section.table.headers.map((header) => header.key);
  }
}
